import React, { useState, useRef, useEffect } from 'react';

// Inline "+New" category button with auto-expand input
export const CategoryNewButton: React.FC<{ onAdd: (cat: string) => void; disabled?: boolean }> = ({ onAdd, disabled = false }) => {
  const [adding, setAdding] = useState(false);
  const [val, setVal] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (adding) inputRef.current?.focus();
  }, [adding]);

  const commit = () => {
    const t = val.trim();
    if (t) onAdd(t);
    setVal('');
    setAdding(false);
  };

  if (adding) {
    return (
      <input
        ref={inputRef}
        value={val}
        onChange={e => setVal(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') { e.preventDefault(); commit(); }
          if (e.key === 'Escape') { setVal(''); setAdding(false); }
        }}
        onBlur={commit}
        placeholder="New…"
        style={{
          width: 70, padding: '6px 7px',
          borderRadius: 8, fontSize: 11,
          border: '1px solid rgba(139,92,246,0.5)',
          background: 'rgba(139,92,246,0.12)', color: '#f0f0f5',
          outline: 'none', fontFamily: "'Syne', sans-serif",
          boxSizing: 'border-box',
        }}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => !disabled && setAdding(true)}
      disabled={disabled}
      style={{
        padding: '6px 8px', borderRadius: 8, flexShrink: 0,
        border: '1px dashed rgba(139,92,246,0.4)',
        background: 'transparent', color: 'rgba(139,92,246,0.75)',
        fontSize: 11, fontWeight: 700, cursor: disabled ? 'not-allowed' : 'pointer',
        fontFamily: "'Syne', sans-serif",
        whiteSpace: 'nowrap',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      + New
    </button>
  );
};
